import dynamic from 'next/dynamic';
import Box from '@mui/material/Box';
import Typography  from '@mui/material/Typography'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Link from 'next/link';
import { useSelector } from 'react-redux';
import { trimSp } from '@components/config/helpers';
import usePricingModel from '@components/_hooks/usePricingModel';
import CallbackIcon from '@mui/icons-material/PhoneCallback';
import useToggleState from '@components/_hooks/useToggleState';
import useGlobalSettings from '@components/_hooks/useGlobalSettings';
import useShowCallback from 'modules/CallbackRequest/hooks/useShowCallback';
import useSalesTelephone from '@components/_hooks/useSalesTelephone';

const DynamicSwitch = dynamic(() => import("../Reusables/Components/DynamicSwitch"), {ssr: false});
const BoxContainer = dynamic(() => import("@components/Components/Reusables/BoxContainerV2"));
const InfoTooltip = dynamic(() => import("../Reusables/Tooltips/InfoTooltip"), {ssr: false});
const CallbackRequestDialog = dynamic(() => import("modules/CallbackRequest/components/CallbackRequestDialog"), {ssr: false});
const StyledBox = dynamic(() => import("@components/Custom/Box/StyledBox"));

const styles = {
	cursor: 'pointer',
    marginLeft: '5px',
   	marginTop: '1px'
}

const vertical = {
	display: 'flex',
	alignItems: 'center'
}

const HeaderBar1 = () => {

	const {getSetting} = useGlobalSettings();
	const {pricing_model, setPricingModel, showPricingModel, disabledToggle} = usePricingModel();
	const {open, handleToggle} = useToggleState();
	const show_callback = useShowCallback();
	const stickerTopBar = getSetting('sticky_top_bar', 'no') == 'yes';

	const handleRequestCallback = () => {
		handleToggle();
	}

	const sales_telephone = useSalesTelephone();

	return (
		<>
			{open && (
				<CallbackRequestDialog 
					open={open}
					handleToggle={handleToggle}
				/>
			)}
			<Box 
				
				sx={{
					...(showPricingModel ? {
						minHeight: '38px'
					} : {
						pt: 0.5, 
						pb: 0.5,
					}),
					...(stickerTopBar && {
						position: 'sticky',
						top: 0,
						zIndex: 1000
					}),
					color:'primary',
					textAlign:'start', 
					backgroundColor: 'primary.main'/*alpha('#fff', 0.5)*/, 
				}}
			>
				<BoxContainer className={'d-flex justify-space-between'}>
					<Box sx={vertical}>
						<div className='d-flex'>
							<Link href={`tel:${trimSp(sales_telephone)}`}>
								<Box sx={{...vertical, color:'#fff',  display: 'flex', flexDirection:'row',}}>
									<LocalPhoneIcon size={10}/>
									<Typography sx={styles} className={`f-medium`} variant={'span'}>{sales_telephone}</Typography>
								</Box>
							</Link>
								{show_callback && <Box onClick={handleRequestCallback} className='ml-4 pointer' sx={{...vertical, color:'#fff',  display: 'flex', flexDirection:'row',}}>
									<CallbackIcon size={10}/>
									<span>Request Callback</span>
								</Box>}
						</div>
					</Box>
					{
						showPricingModel && (
							<div className="d-flex">
								<DynamicSwitch 
									labels={[<>NON-EXHIBITION <span className="white font-light">pricing</span></>, <>EXHIBITION <span className="font-light white">(all inclusive) pricing</span></>]}
									value={pricing_model === 1}
									onChange={(e) => setPricingModel(e.target.checked ? 1 : 0)}
									onColor="white.main" 
									offColor="#ffff00"
									typohraphyClassNames="fs-18"
									disabled={disabledToggle}
								/>
								<InfoTooltip color="#ffff00" title="Price includes delivery, build, takedown &amp; collection" />
							</div>
						)
					}
					<Box className="text-vertical">
						<Link href={'/tracking'}>
							<Box sx={{...vertical, color:'#fff',  display: 'flex', flexDirection:'row', marginRight: 1.4}}>
								<LocationOnIcon size={10}/>
								<Typography sx={styles} className={`f-medium`} variant={'span'} >
								Track My Order
								</Typography>
							</Box>
						</Link>
					</Box>
				</BoxContainer>
			</Box>
		</>
	)
}

export default HeaderBar1;